import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkConfig } from '../../../async-thunk-config';
import { HomeError } from '../../home';
import {
  ElencoDominioRequest,
  ElencoDominioResponse,
} from '../../../../api/generated/dob';
import { utilityRepository } from '../../../../repositories/dob/utility/utility-repository';

export const getDominio = createAsyncThunk<
  ElencoDominioResponse,
  ElencoDominioRequest,
  AsyncThunkConfig<HomeError>
>('get-utility-dominio', async (request: ElencoDominioRequest, thunkApi) => {
  try {
    return await utilityRepository.getDominio(request, thunkApi);
  } catch (error) {
    console.error(error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});
